import { Outlet } from 'react-router-dom';

/**
 * AuthLayout — shell minimalista para /login y rutas relacionadas con
 * autenticación (recuperación de contraseña, callback de Stitch, etc.).
 * Centra el contenido sobre el fondo neutro del tema.
 */
export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-muted/40 flex items-center justify-center p-6">
      <Outlet />
    </div>
  );
}
